import AddStoreForm from "components/forms/AddStoreForm";
import InvestorForm from "components/forms/InvestorForm";
import JTCEmployeeForm from "components/forms/JTCEmployeeForm";
import LegalEntityForm from "components/forms/LegalEntityForm";
import RegistrationForm from "components/forms/RegistrationForm";
import AddBlogForm from "./AddBlogForm";
import AdminUserRegistrationForm from "./AdminUserRegistrationForm";
import KYCForm from "./KYCForm";
import AddUserForm from "./AddUserForm";
import AddAnnualProgressForm from "./AddAnnualProgressForm";


export {AddAnnualProgressForm,AddUserForm,KYCForm,AddStoreForm, InvestorForm, LegalEntityForm, JTCEmployeeForm, RegistrationForm,AddBlogForm,AdminUserRegistrationForm}
